(function() {
  // Use our own guard so this script always runs once, independently of the
  // widget's own inline deduper. Also set the widget's flag to suppress its
  // duplicate inline deduper if it loads after us.
  if (window.__altenewTscCalendarInit) return;
  window.__altenewTscCalendarInit = true;
  window.tscModalDeduperInitialized = true;

  function hideEmptyTimeLinks() {
    var events = document.querySelectorAll('.calendar-event');
    for (var i = 0; i < events.length; i++) {
      var eventEl = events[i];
      var links = eventEl.querySelectorAll('.tsc--eventModalLink');
      var hasVisibleText = false;
      for (var j = 0; j < links.length; j++) {
        var text = links[j].textContent.trim().replace(/\u00a0/g, '');
        if (text !== '') {
          hasVisibleText = true;
          break;
        }
      }
      if (!hasVisibleText && links.length > 0) {
        eventEl.style.setProperty('display', 'none', 'important');
      }
    }
  }

  // Migrated from altenew.js: Apply custom colors to event links based on original foreground color
  function applyStylesToEventLinks() {
    var eventLinks = document.querySelectorAll('.title.tsc--eventModalLink');
    for (var i = 0; i < eventLinks.length; i++) {
      var link = eventLinks[i];
      var BGcolor = window.getComputedStyle(link).color;
      if (BGcolor === "rgb(140, 40, 40)") {
        link.style.backgroundColor = "#95c67f";
        link.style.color = "#fff";
      } else if (BGcolor === "rgb(55, 135, 35)") {
        link.style.backgroundColor = "#ce3d1a";
        link.style.color = "#fff";
      } else if (BGcolor === "rgb(66, 215, 95)") {
        link.style.backgroundColor = "#6da0ed";
        link.style.color = "#fff";
      } else if (BGcolor === "rgb(20, 20, 160)") {
        link.style.backgroundColor = "#907ec5";
        link.style.color = "#fff";
      } else {
        link.style.color = "#fff";
        link.style.backgroundColor = "#c47da2";
      }
    }
  }

  function normalizeTscModal() {
    hideEmptyTimeLinks();
    applyStylesToEventLinks();

    var modals = Array.prototype.slice.call(document.querySelectorAll('#tsc--eventModal'));
    if (!modals.length) return;

    var latestModal = modals[modals.length - 1];

    for (var i = 0; i < modals.length - 1; i++) {
      modals[i].remove();
    }

    if (latestModal.parentNode !== document.body) {
      document.body.prepend(latestModal);
    }
  }

  function queueNormalize() {
    window.setTimeout(normalizeTscModal, 0);
    window.setTimeout(normalizeTscModal, 100);
    window.setTimeout(normalizeTscModal, 300);
  }

  function debounce(fn, wait) {
    var timer;
    return function() {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  // Check if calendar pagination target exists on initial load.
  // Capped so it stops polling if the widget never renders (e.g. network failure).
  function checkIfElementExists() {
    var attempts = 0;
    var interval = setInterval(function() {
      attempts++;
      var targetElement = document.querySelector('.calendar .calendar-pagination');
      if (targetElement && (targetElement.offsetWidth > 0 || targetElement.offsetHeight > 0)) {
        applyStylesToEventLinks();
        clearInterval(interval);
      } else if (attempts >= 15) {
        clearInterval(interval);
      }
    }, 2000);
  }

  checkIfElementExists();

  // DOM and Click listeners
  document.addEventListener('click', function(event) {
    if (event.target.closest('.tsc--eventModalLink, .next-month-btn, .previous-month-btn, .selected-month-btn')) {
      queueNormalize();
    }
    
    // Month navigation style updates
    if (event.target.closest('.calendar .next-month-btn, .calendar .previous-month-btn, .calendar .selected-month-btn')) {
      setTimeout(function() {
        applyStylesToEventLinks();
      }, 2000);
    }

    // Today's event click delegate
    var calendarEl = event.target.closest('.calendar');
    if (calendarEl && event.target.closest('.calendar-date.today.current-month.has-events')) {
      setTimeout(function() {
        var modalLink = document.querySelector('.tsc--eventModalLink');
        if (modalLink) {
          modalLink.click();
        }
      }, 3500);
    }
  });

  // Debounced: coalesce mutation bursts (e.g. month navigation re-rendering the
  // grid) into a single normalize pass instead of running the DOM-wide queries
  // and getComputedStyle reflows on every individual mutation.
  if (window.MutationObserver) {
    var observer = new MutationObserver(debounce(normalizeTscModal, 150));

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Trigger click on today's date if it has events (loaded initially)
  setTimeout(function() {
    var todayBtn = document.querySelector('.calendar-date.today.current-month.has-events');
    if (todayBtn) {
      todayBtn.click();
    }
  }, 3500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeTscModal);
  } else {
    normalizeTscModal();
  }
})();
